(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/engine-provider.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/engine-provider.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.engine,
  makeEngineState = _svs$components$tipse.makeEngineState,
  actions = _svs$components$tipse.actions,
  definitions = _svs$components$tipse.definitions;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _React = React,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo,
  createContext = _React.createContext;
const EngineProviderContext = createContext();
const EngineProvider = _ref => {
  let children = _ref.children;
  const currentEngine = ReactRedux.useSelector(selectEngineDefinition);
  const _ReactRedux = ReactRedux,
    useDispatch = _ReactRedux.useDispatch;
  const dispatch = useDispatch();
  const switchEngine = useCallback(engineName => {
    const initialState = makeEngineState(definitions[engineName]);
    if (engineName !== currentEngine) {
      dispatch(actions.switchEngine({
        engineName,
        initialState
      }));
    }
  }, [currentEngine, dispatch]);
  const value = useMemo(() => ({
    switchEngine,
    currentEngine
  }), [switchEngine, currentEngine]);
  return React.createElement(EngineProviderContext.Provider, {
    value: value
  }, children);
};
setGlobal('svs.components.tipsen.engine.EngineProvider', EngineProvider);
setGlobal('svs.components.tipsen.engine.EngineProviderContext', EngineProviderContext);

 })(window);